import { createContext } from 'react'
import { Concept } from '@fusion-advantage/formlib'
import { XpathsValued, XpathValueDeterminer } from '../../../lib/form/useXpathsValued2'

export interface L6FormContextValue {
	jumpToConcept: (conceptOrCid: Concept|string) => void
	setXpathValuedDeterminer: (xpath: string, determiner: XpathValueDeterminer) => void
	refreshXpathsValued: () => void
	xpathsValued: XpathsValued
}

const L6FormContext = createContext<L6FormContextValue>({
	jumpToConcept(conceptOrCid) {
		alert('[L6FormContext] no handler for jumpToConcept')
	},
	setXpathValuedDeterminer(xpath, determiner) {
		alert('[L6FormContext] no handler for setXpathValued')
	},
	refreshXpathsValued() {
		alert('[L6FormContext] no handler for refreshXpathsValued')
	},
	xpathsValued: {},
})

export default L6FormContext
